import useUser from "@/hooks/useUser";
import { useAppSelector } from "@/redux/store/hooks";
import type { Brainstormer } from "@/types";

// Banners render several brainstormers at once and don't populate
// `state.brainstormers.brainstormer`, so they must pass their own layout.
export function useCanCreatePost(layout?: Brainstormer["layout"]): boolean {
  const { isUserAdmin } = useUser();
  const roleInCurrentContext = useAppSelector(
    (state) => state.project?.project?.roleInCurrentContext
  );
  const currentLayout = useAppSelector(
    (state) => state.brainstormers?.brainstormer?.layout
  );
  const resolvedLayout = layout ?? currentLayout;

  return Boolean(
    resolvedLayout !== "BudgetAllocator" ||
    (isUserAdmin && roleInCurrentContext !== "participant")
  );
}

export default useCanCreatePost;
